import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LargePrimaryNavigation from "./LargePrimaryNavigation";
import {
  maleLargePrimaryNavigationItems,
  femaleLargePrimaryNavigationItems,
  setNavActiveItem,
  getNavActiveItem,
  clearNavActiveItem
} from "../../../state/modules/navigation";
import { MALE, FEMALE } from "../../../state/modules/layout";

const itemsSelector = (forGender, state) => {
  switch (forGender) {
    case MALE:
      return maleLargePrimaryNavigationItems(state);
    case FEMALE:
      return femaleLargePrimaryNavigationItems(state);
    default:
      return [];
  }
};

const mapStateToProps = (state, { forGender }) => ({
  currentGender: state.layout.gender,
  items: itemsSelector(forGender, state),
  largeNavActiveItemId: getNavActiveItem(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setNavActiveItem, clearNavActiveItem }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LargePrimaryNavigation);
